"use client";

import { Button } from "@cappelendamm/design-system/react";
import { getPageLink } from "@/navigation/selectors";
import classNames from "classnames";
import Link from "next/link";
import { ALPHABET } from "@/app/[code]/[universeTag]/(shop)/authors/[[...char]]/constants";
import { useRef } from "react";
import { PiCaretLeft, PiCaretRight } from "react-icons/pi";

export const CharPicker = ({ character }: { character?: string }) => {
  const navRef = useRef<HTMLElement | null>(null);
  return (
    <div className="relative flex sm:block">
      <button
        type="button"
        aria-label="Scroll venstre"
        className="absolute left-[-16px] sm:hidden"
        onClick={() => {
          if (navRef.current)
            navRef.current.scrollBy({ left: -150, behavior: "smooth" });
        }}
      >
        <div className="flex h-[64px] w-[48px] items-center justify-center">
          <PiCaretLeft />
        </div>
      </button>
      <nav
        id="alphabet-nav"
        ref={navRef}
        style={{ scrollBehavior: "smooth" }}
        aria-label="Author surname initial"
        className="mx-6 flex gap-4 overflow-auto py-2 sm:grid sm:grid-cols-[repeat(auto-fill,minmax(3rem,1fr))]"
      >
        {ALPHABET.map((c) => (
          <Button
            key={c}
            variant="secondary-small"
            href={getPageLink({ pageType: "authors", params: c })}
            className={classNames("aspect-square w-full rounded-full", {
              "bg-[var(--cvr-button-background)] text-[var(--cvr-button-contrast)]":
                character === c,
            })}
            as={Link}
          >
            {`${c}`}
          </Button>
        ))}
      </nav>
      <button
        type="button"
        aria-label="Scroll høyre"
        className="absolute right-[-16px] sm:hidden"
        onClick={() => {
          if (navRef.current)
            navRef.current.scrollBy({ left: 150, behavior: "smooth" });
        }}
      >
        <div className="flex h-[64px] w-[48px] items-center justify-center">
          <PiCaretRight />
        </div>
      </button>
    </div>
  );
};
